import * as React from "react";
import { RgbaColorPicker } from "react-colorful";
import { useTimeTableColor } from "../../state/storeTimeTableColor";
import ShowHideHightLight from "./ShowHideHightLight";
import SaveColorBtn from "./SaveColorBtn";
import SwitchColorPanel from "./SwitchColorPanel";
import { useControlScroll } from "../../hooks/useControlScroll";

const ColorPickerText = () => {
    const updateShowTextColor = useTimeTableColor((state) => state.updateShowTextColor);
    const updateFirstText = useTimeTableColor((state) => state.updateFirstText);
    const updateSecondText = useTimeTableColor((state) => state.updateSecondText);
    const updateEvenText = useTimeTableColor((state) => state.updateEvenText);
    const updateOddText = useTimeTableColor((state) => state.updateOddText);
    const updateLightText = useTimeTableColor((state) => state.updateLightText);

    const rgba_first_text = useTimeTableColor((state) => state.rgba_first_text);
    const rgba_second_text = useTimeTableColor((state) => state.rgba_second_text);
    const rgba_even_text = useTimeTableColor((state) => state.rgba_even_text);
    const rgba_odd_text = useTimeTableColor((state) => state.rgba_odd_text);
    const rgba_light_text = useTimeTableColor((state) => state.rgba_light_text);

    const { controlCustomScroll, refScroll } = useControlScroll();

    return (
        <div
            onScroll={controlCustomScroll}
            ref={refScroll}
            className="bg-white flex-col overflow-x-hidden min-w-fit h-screen py-6 px-3"
        >
            <div className="py-3 flex flex-col gap-1">
                <button
                    className="bg-blue-600 px-2 py-2 rounded-md text-white"
                    onClick={() => updateShowTextColor(false)}
                >
                    Click To Switch: Now is Text Color
                </button>
                <ShowHideHightLight />
                <SaveColorBtn />
            </div>

            {/* First Head Text */}
            <div className="py-4">
                <div>First Head Text</div>
                <RgbaColorPicker
                    id="first-head-text"
                    color={rgba_first_text}
                    onChange={updateFirstText}
                />
                <SwitchColorPanel />
            </div>

            {/* Second Head Text */}
            <div className="py-4">
                <div>Second Head Text</div>
                <RgbaColorPicker
                    id="second-head-text"
                    color={rgba_second_text}
                    onChange={updateSecondText}
                />
                <SwitchColorPanel />
            </div>

            {/* Odd Row Text */}
            <div className="py-4">
                <div>Odd Row Text</div>
                <RgbaColorPicker
                    id="odd-row-text"
                    color={rgba_odd_text}
                    onChange={updateOddText}
                />
                <SwitchColorPanel />
            </div>

            {/* Even Row Text */}
            <div className="py-4">
                <div>Even Row Text</div>
                <RgbaColorPicker
                    id="even-row-text"
                    color={rgba_even_text}
                    onChange={updateEvenText}
                />
                <SwitchColorPanel />
            </div>

            {/* Highlight Row Text */}
            <div className="py-4">
                <div>Highlight Row Text</div>
                <RgbaColorPicker
                    id="highlight-row-text"
                    color={rgba_light_text}
                    onChange={updateLightText}
                />
                <div className="flex items-center">
                    <SwitchColorPanel />
                    <ShowHideHightLight />
                </div>
            </div>

            <div className="py-44"></div>
        </div>
    );
};

export default ColorPickerText;
